import { Storage as StorageFactory } from './storage';

const Storage = new StorageFactory();

export { Storage };
